
angular.module('app.services.right_slide_mobile_menu', [])
  .factory('MobileMenu', ['$rootScope','$log','$timeout', function($rootScope, $log, $timeout) {

  return {
    // init, select dom elements
    init: function () {
      this.nav = angular.element(document.querySelector('nav.collapse'));
      this.body = angular.element(document.querySelector('body'));
      this.navContentOverlay = angular.element(document.querySelector('nav.nav-content-overlay'));
      this.containerCanvas = angular.element(document.querySelector('.container-canvas'));

      this.sizeOffset = -30;
      this.body.css('overflow-x', 'hidden');
    },

    // set height as needeed
    setDimensions: function () {
      this.width = this.containerCanvas[0].offsetWidth;
      this.height = this.containerCanvas[0].offsetHeight;
      this.nav.css('height', this.height + 'px');
    },

    // toggle nav
    toggle: function () {
      this.on = !this.on;

      if (this.on) {
        this.setDimensions();
        $log.debug('MobileMenu(): toggling menu on sizeoffset = '+this.sizeOffset);
        $(".navbar-collapse").css('right', this.sizeOffset + 'px');
      } else {
        $log.debug('MobileMenu(): toggling menu off = '+this.sizeOffset);
        $(".navbar-collapse").css('right','-1000px');
      }
    }

  };

}]);
